// @flow strict
export type queryParamsObject = { [key: string]: string | number }

const objectToQueryString = (
  queryParams: queryParamsObject,
  options?: {
    startWithQuestionMark?: boolean,
    encoded?: boolean,
  },
) =>
  Object.keys(queryParams).reduce((accumulator, queryParam, index) => {
    const seperator =
      options && options.startWithQuestionMark && index === 0 ? '?' : '&'

    const finalQueryString =
      options && options.encoded
        ? // encodeURIComponent coerces type any to string
          // but is typed as only receiving string, so we coerce to string beforehand
          encodeURIComponent(String(queryParams[queryParam]))
        : queryParams[queryParam]

    return `${accumulator}${seperator}${queryParam}=${finalQueryString}`
  }, '')

export default objectToQueryString
